<template>
  <div>
    <div class="icons_achievement_row">
      <div class="reward_points" v-if="achievementInfo.prizeType === prizeTypes.POINTS">
        <img src="static/images/achievements/icon-reward-points.svg" alt="">
        <div class="reward_label">+{{ achievementInfo.prizeValue }} {{ getTranslations.home_modals_achievements_reward_points }}</div>
      </div>
      <div class="reward_points" v-if="achievementInfo.prizeType === prizeTypes.SPINNING_WHEEL">
        <img src="static/images/achievements/icon-reward-spin.svg" alt="">
        <div class="reward_label">+{{ achievementInfo.prizeValue }} SPIN</div>
      </div>
    </div>
    <span v-if="achievementInfo.prizeType === prizeTypes.SPINNING_WHEEL">
    <button type="button"
            :class="['claim_prize new_ach_btn', { deactivated: isAlreadyRedeemed }]"
            v-if="!disablePlay"
            @click.prevent="spin()">
      {{ getTranslations.home_modals_achievements_reward_spin }}
    </button>
      </span>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import SpinWheel from '@/components/home/modals/spinwheel/SpinWheel';

export default {
  name: 'achievement-reward',
  emits: ['read'],
  components: {
    SpinWheel,
  },
  props: {
    achievementInfo: Object,
    disablePlay: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showPrizeInfo: false,
      prizeTypes: {
        POINTS: 'POINTS',
        SPINNING_WHEEL: 'SPINNING_WHEEL',
      },
    };
  },
  methods: {
    ...mapMutations('profile', [
      'setRedeemedNotification',
    ]),
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    spin() {
      this.storeModalForHomePage(SpinWheel);
    },
  },
  beforeDestroy() {
    if (this.achievementInfo.prizeType !== this.prizeTypes.SPINNING_WHEEL || this.isAlreadyRedeemed) {
      this.setRedeemedNotification(this.checkedNotificationId);
      this.$emit('read', this.checkedNotificationId);
    }
  },
  computed: {
    ...mapState('profile', [
      'achievementNotificationData',
      'checkedNotificationId',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    isAlreadyRedeemed() {
      const { categoryName, achievementLevelName } = this.achievementInfo;
      const matchingNotifications = (this.achievementNotificationData || []).filter(notification => notification.text === `${categoryName}_${achievementLevelName}`);
      if (!matchingNotifications.length) {
        return false;
      }
      const { readStatus } = matchingNotifications[0];
      return readStatus;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/AchievementReward.vue